var map = {
	"./icon_position_type_ca.png": 780,
	"./icon_position_type_cadeira_praia.png": 781,
	"./icon_position_type_cd.png": 782,
	"./icon_position_type_dd.png": 783,
	"./icon_position_type_dld.png": 784,
	"./icon_position_type_dle.png": 785,
	"./icon_position_type_dorso_canivete.png": 786,
	"./icon_position_type_dorso_elevado.png": 787,
	"./icon_position_type_dv.png": 788,
	"./icon_position_type_ginecologica.png": 789,
	"./icon_position_type_litotomia.png": 790,
	"./icon_position_type_sentado.png": 791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 779;